import { render } from "./KnowledgeView.vue?vue&type=template&id=2d54f803&scoped=true"
import script from "./KnowledgeView.vue?vue&type=script&lang=js"
export * from "./KnowledgeView.vue?vue&type=script&lang=js"

import "./KnowledgeView.vue?vue&type=style&index=0&id=2d54f803&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d54f803"]])

export default __exports__